import { render, staticRenderFns } from "./CustomerGroup.vue?vue&type=template&id=62e3228a&scoped=true"
import script from "./CustomerGroup.vue?vue&type=script&lang=js"
export * from "./CustomerGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e3228a",
  null
  
)

export default component.exports